.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  min-block-size: var(--control-sm);
  color: var(--color-text);
  font-size: var(--text-md);
  line-height: var(--leading-tight);
  cursor: default;
}

.box {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  inline-size: var(--icon-sm);
  block-size: var(--icon-sm);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  background: var(--color-surface);
  color: var(--color-accent-contrast);
  transition:
    background-color var(--duration-fast) ease,
    border-color var(--duration-fast) ease;
}

.box[data-checked],
.box[data-indeterminate] {
  border-color: var(--color-accent);
  background: var(--color-accent);
}

.box[data-disabled] {
  border-color: var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-subtle);
}

.box:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.indicator {
  display: inline-flex;
}

.indicator[data-unchecked] {
  visibility: hidden;
}

.description {
  padding-inline-start: calc(var(--icon-sm) + var(--space-2));
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}
